import { useEffect } from "react";
import { ChatProvider } from "@/context/ChatContext";
import { useAuth } from "@/context/AuthContext";
import { resolveImg } from "@/lib/api";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { ChatDrawer } from "@/components/chat/ChatDrawer";
import { DmRequestWatcher } from "@/components/chat/DmRequestWatcher";

export function Layout({ children }) {
  const { site } = useAuth();
  const accent = site?.accent_color || "#00F0FF";

  useEffect(() => {
    document.documentElement.style.setProperty("--cx-cyan", accent);
  }, [accent]);

  return (
    <ChatProvider>
      <div className="min-h-screen bg-[#05070D] text-slate-100 flex flex-col relative">
        {site?.background_image && (
          <div className="fixed inset-0 z-0 pointer-events-none" data-testid="site-background">
            <img src={resolveImg(site.background_image)} alt="" className="h-full w-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#05070D]/70 via-[#05070D]/85 to-[#05070D]" />
          </div>
        )}
        <div className="relative z-10 flex flex-col min-h-screen">
          <Header />
          <AnnouncementBar />
          <main className="flex-1">{children}</main>
          <Footer />
        </div>
        <ChatDrawer />
        <DmRequestWatcher />
      </div>
    </ChatProvider>
  );
}
